import {Card, Col, Layout, message, Row} from "antd";
import {Content} from "antd/es/layout/layout";
import styles from "./menuContainer.module.scss";
import {useInjection} from "inversify-react";
import ApiService from "../../services/apiService";
import {useCallback, useEffect, useState} from "react";
import {MenuApi, MenuCreateDto, MenuDto, MenuUpdateDto} from "../../api";
import {CrudForm, CrudFormItemProps, nameof} from "digimuth-components/dist";
import BeeftekaFileUploader from "../components/fileUploader/beeftekaFileUploader";

export default function MenuContainer() {
    const apiService = useInjection(ApiService);

    const [menu, setMenu] = useState<MenuDto | null>(null);

    const fetchMenu = useCallback(async () => {
        try {
            const response = await apiService.getApi(MenuApi).apiMenuGet()
            if (response.data.length) {
                setMenu(response.data.pop()!);
            }
        } catch (e: any) {
            return e.response?.data;
        }
    }, [apiService]);

    useEffect(() => {
        fetchMenu();
    }, [fetchMenu]);

    const formItems: CrudFormItemProps[] = [
        {
            label: "Menu",
            name: nameof<MenuCreateDto>("menuFileId"),
            rules: [
                {required: true, message: 'To pole jest wymagane'}
            ],
            children: <BeeftekaFileUploader
                accept="application/pdf"
                defaultFile={menu?.id ? {
                    uid: menu.menuFileId!.toString(),
                    name: menu.menuFile?.fileName || "",
                    originFileObj: (menu?.menuFile as any).originFileObj
                } : undefined}
            />
        }, {
            label: "Angielskie menu",
            name: nameof<MenuCreateDto>("englishMenuFileId"),
            children: <BeeftekaFileUploader
                accept="application/pdf"
                defaultFile={menu?.id ? {
                    uid: menu.englishMenuFileId!.toString(),
                    name: menu.englishMenuFile?.fileName || "",
                    originFileObj: (menu?.menuFile as any).originFileObj
                } : undefined}
            />
        }
    ]

    const onSubmit = async (values: MenuCreateDto | MenuUpdateDto) => {
        try {
            await apiService.getApi(MenuApi).apiMenuPost(values);
            message.success("Dane zapisane poprawnie.", 2);
        } catch (e: any) {
            message.error("Wystąpił błąd.", 2);
            return e.response.data;
        }
    }

    return <Layout style={{backgroundColor: "white"}}>
        <h1>Menu restauracji</h1>
        <Content className={styles.content}>
            <Row>
                <Col xs={24} lg={20} xl={15} xxl={10}>
                    <Card title="Plik PDF zawierający menu">
                        <CrudForm
                            formItems={formItems}
                            onSubmit={onSubmit}
                            saveButtonTitle="Zapisz"
                        />
                    </Card>
                </Col>
            </Row>
        </Content>
    </Layout>
}
